import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "./QueryDropDown.css";

type QueryDropDownProps = {
  stateManage: any;
  fromPage?: string;
  filterData: Array<any>;
};
const QueryDropDown = (props: QueryDropDownProps) => {
  const { filterData = [], stateManage = {}, fromPage = "" } = props;

  const { searchTerm = "" } = stateManage;
  const theme = useTheme();
  const { t } = useTranslation();

  const filterQueryAdd = (filteredNames: any = [], searchTerm1 = "") => {
    if (filteredNames?.length > 0 && ("" + searchTerm1).length > 0) {
      return `${t("categories")} = ${filteredNames.join(", ")} ${t(
        "and_search_terms",
      )} "${searchTerm1}"`;
    } else if (filteredNames?.length > 0) {
      return `${t("categories")} = ${filteredNames.join(", ")}`;
    } else if (("" + searchTerm1).length > 0) {
      return `${t("search_term")} = "${searchTerm1}"`;
    } else {
      return `${t("all")}`;
    }
  };

  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);
  const [, setIndex] = useState(0);

  const handleViewQueryClick = (index: number) => {
    setIndex(index);
    setOpen(false);
  };

  const handleQueryToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleQueryClose = (event: Event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (fromPage === "ecom") {
      const filteredNames = filterData
        .filter((item) => item.isCheck)
        .map((item) => `"${item.name}"`);
      const finalData = `${filterQueryAdd(filteredNames, searchTerm)} ${t("orderByCreateQuery")}`;
      const newOption = Object.assign([], options, { 0: finalData });
      setOptions(newOption);
    } else {
      const filteredNames = filterData.map((item) => `"${item}"`);
      const finalData = `${filterQueryAdd(filteredNames, searchTerm)} ${t("orderByCreateQuery")}`;
      const newOption = Object.assign([], options, { 0: finalData });
      setOptions(newOption);
    }
  }, [filterData, searchTerm]);

  return (
    <Box component='span' className='ecommerce-dropdown-custom'>
      <ButtonGroup
        onClick={handleQueryToggle}
        sx={{ position: "relative" }}
        disableRipple
        size='small'
        variant='text'
        ref={anchorRef}
        aria-label='View Query'>
        <Button
          sx={{
            paddingRight: "30px",
            textTransform: "none",
          }}>
          <Typography color='activeColor'>{t("View_Query")}</Typography>
        </Button>
        <Button
          size='small'
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label='view query'
          aria-haspopup='menu'
          className='dropdown-button'
          sx={{
            color: theme.palette.customColor.TERTIARY,
          }}>
          {open ? <KeyboardArrowDownIcon /> : <NavigateNextIcon />}
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placeholder={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom" ? "center top" : "center bottom",
            }}>
            <Paper>
              <ClickAwayListener onClickAway={handleQueryClose}>
                <MenuList id='split-button-menu' autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      sx={{ width: { sx: "300px", md: "600px" }, whiteSpace: "normal" }}
                      selected={index === 0}
                      disabled={index === 0}
                      // eslint-disable-next-line @typescript-eslint/no-unused-vars
                      onClick={(event) => handleViewQueryClick(index)}>
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
};

export default QueryDropDown;
